import  { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import Tickets from "./caroselcontent/Tickets";
import BuildIDLogo from "../../../assets/images/build_id_logo.png";
import Sites from "./caroselcontent/Sites";
import Chat from "./caroselcontent/Chat";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useEffect } from "react";
import {
  Box,
  Button,
  Modal,
} from "@mui/material";
import { English } from "../../../constant/EnglishFallback";
import { useSelector, useDispatch } from "react-redux";
import Timesheet from "./caroselcontent/Timesheet";
import Expense from "./caroselcontent/Expense";
import CarPool from "./caroselcontent/CarPool";
import JobPosting from "./caroselcontent/JobPosting";
import { BIBlue, BIGrey, BILightGrey } from "../../../assets/helpers";
import { useNavigate } from "react-router";
import { setLogindata } from "../../../redux/actions/actions";

const TakeTour = (props) => {
  var isAndroid = /Android/i.test(navigator.userAgent);
  var isIphone = /iPhone/i.test(navigator.userAgent);
  var isIpad = /iPad/i.test(navigator.userAgent);


  const [open, setOpen] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { multiLanguageData, loginData } = useSelector((state) => state?.main);
  const rawLoginData = useSelector((state) => state.main?.loginData);
  const { sourceDataFrom, ...filteredLoginData } = rawLoginData || {};

  const handleButtonClick = () => {
    setActiveSlide(0);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (props?.closeTourFromFinishPage) props?.closeTourFromFinishPage();
  };

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  useEffect(() => {
    if (props?.fromCreateAccount) {
      handleButtonClick();
    }
  }, []);

  const handleSkip = () => {
    handleClose();
    dispatch(setLogindata(filteredLoginData))
    navigate("/home")
  };

  const handleGetStarted = () => {
    handleClose();
    if (loginData?.userInformation?.UserId) {
      if (isAndroid) {
        const url = `intent://#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
        window.location.replace(url);
      } else if (isIphone || isIpad) {
        const start = new Date().getTime();
        const url = "mybuilderid://"; // Custom URL scheme for your app
        const appStoreURL =
          "https://apps.apple.com/in/app/buildid-connect-share-build/id1490164104"; // Replace with your App Store URL
        let isAppOpened = false;

        const handleVisibilityChange = () => {
          if (document.visibilityState === "hidden") {
            isAppOpened = true;
          }
        };
        // Add the visibility change listener
        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Attempt to open the app
        window.location = url;
        setTimeout(() => {
          // If the app wasn't opened, redirect to the App Store
          if (!isAppOpened && new Date().getTime() - start < 500) {
            window.location = appStoreURL;
          }
          // Cleanup the event listener
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange,
          );
        }, 0);
      } else {
        dispatch(setLogindata(filteredLoginData))
        navigate("/home")
      }
    }
  };

  const {
    TEXT_TAKE_A_TOUR = English?.TakeATour?.TEXT_TAKE_A_TOUR,
    BUTTON_SKIP = English?.TakeATour?.BUTTON_SKIP,
    BUTTON_GET_STARTED = English?.TakeATour?.BUTTON_GET_STARTED
  } = multiLanguageData?.TakeATour || {}

  return (
    <div className="taketour">
      {!props?.fromCreateAccount && (
        <Button onClick={handleButtonClick} color="primary">
          {TEXT_TAKE_A_TOUR}
        </Button>
      )}
      <Modal open={open}>
        <Box className="user-modal-responsive" sx={{ p: 2, textAlign: "center" }}>
          <Box
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <img style={{ height: "50px" }} src={BuildIDLogo} alt="" />
            {/* <Stack direction={"row"}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Stack> */}
          </Box>
          <Carousel
            showThumbs={false}
            showArrows={true}
            showIndicators
            autoFocus={true}
            swipeable={true}
            emulateTouch={true}
            useKeyboardArrows={true}
            showStatus={false}
            dynamicHeight={false}
            width="100%"
            selectedItem={activeSlide}
            onChange={handleSlideChange}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const style = {
                width: "8px",
                height: "8px",
                margin: "0 5px",
                background: isSelected ? BIBlue : BIGrey,
                borderRadius: "50%",
                cursor: "pointer",
                display: "inline-block",
                textAlign: "center",
              };
              return (
                <li
                  style={style}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  title={`${label} ${index + 1}`}
                />
              );
            }}
          >
            <Tickets />
            <Chat />
            <Sites />
            <Timesheet />
            <Expense />
            <JobPosting />
            <CarPool onClose={handleClose} />
          </Carousel>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleSkip}
            >
              {BUTTON_SKIP}
            </Button>
            <Button
              variant="contained"
              style={{ background: activeSlide === 6 ? BIBlue : BILightGrey }}
              onClick={handleGetStarted}
              disabled={activeSlide !== 6}
            >
              {BUTTON_GET_STARTED}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default TakeTour;
